const storageKeys = {
    menuItems: 'menuItems',
    resources: 'resources',
    permissions: 'permissions',
    groups: 'groups',
    role: 'role',
    features: 'features',
    selectedLanguage: 'selectedLanguage',
    approval: 'approval',
    userInfo: 'userInfo',
    selfRegUrl: 'selfRegUrl',
    accountName: 'accountName',
    memberGroups: 'memberGroups',
    recentSearch: 'recentSearch'
};

export default storageKeys;
